/** @jsxImportSource @emotion/react */

import { css } from "@emotion/react";

import { useTranslation } from "react-i18next";

import { ROUTES, TUTORIAL_IDS } from "@/shared";
import { useTableHeadStore } from "@/stores/useTableHeadStore";
import { useTableStoreByRoute } from "@/stores/useTableStore";
import Typography from "@mui/material/Typography";

import CheckboxDefaultCheckedIcon from "../../../../../assets/customIcons/checkbox/CheckboxDefaultCheckedIcon";
import useTutorialMode from "../../../../TutorialMode/hooks/useTutorialMode";
import { STEP_GROUP } from "../../../../TutorialMode/types";
import { mobileTableHeadContentStyle } from "../../../styles/styleFunctions";
import { useTableStyles } from "../../../styles/styles";
import MobileTableHeadActive from "./MobileTableHeadActive";

interface MobileTableHeadProps {
  route: ROUTES;
}

const MobileTableHead = ({ route }: MobileTableHeadProps) => {
  const { t } = useTranslation();

  const {
    stepIndex,
    stepGroup,
    callTutorialWithTimeout,
    checkIfCorrectTutorialStep
  } = useTutorialMode();

  const { isCheckable } = useTableStoreByRoute(route);

  const { tableHeadActive, setTableHeadActive } = useTableHeadStore();

  const { mobileTableHead } = useTableStyles();

  const handleSelectRowsClick = () => {
    setTableHeadActive(true);

    if (checkIfCorrectTutorialStep(STEP_GROUP.TutorialApplySchedule, 2)) {
      callTutorialWithTimeout(true, stepIndex + 1, stepGroup, true, 100);
    }
  };

  const renderContent = () => {
    if (!isCheckable) {
      return (
        <div
          css={css({
            height: "32px",
            width: "100%"
          })}
        />
      );
    }

    return tableHeadActive ? (
      <MobileTableHeadActive
        route={route}
        setIsTableheadActive={setTableHeadActive}
      />
    ) : (
      <div
        id={TUTORIAL_IDS.InactiveMobileHead}
        onClick={handleSelectRowsClick}
        css={css(mobileTableHeadContentStyle())}
      >
        <CheckboxDefaultCheckedIcon />

        <Typography variant="body2Medium">
          {t("Button##select rows")}
        </Typography>
      </div>
    );
  };

  return <div css={css(mobileTableHead)}>{renderContent()}</div>;
};

export default MobileTableHead;
